import { computed } from 'vue'
import { useStore } from 'vuex'

export function usePackaging() {
  const store = useStore()
  const checkout = computed(() => store.state.checkout?.checkout)
  const showWrappingSelection = computed(() => checkout.value?.show_wrapping_selection)
  const wrappingOptions = computed(() => checkout.value?.wrappings || [])
  const selectedWrappingOption = computed({
    get() {
      return checkout.value?.cart?.wrapping ?? null
    },
    set(value) {
      store.dispatch('checkout/setWrapping', value)
    },
  })
  const selectedWrappingLabel = computed(() => {
    const selected = selectedWrappingOption.value

    if (!selected) return null
  
    const option = wrappingOptions.value.find(({ type }) => type === selected)
  
    return option?.description ?? null
  })

  return {
    wrappingOptions,
    selectedWrappingLabel,
    showWrappingSelection,
    selectedWrappingOption,
  }
}
